import UUID from "../uuid";
import AdSkipButton from '@javascripts/advertisements/ad_skip_button';

export default class InstreamAdvertisement {
  constructor({ tech, params, ima, data } = {}) {
    this._tech = tech;
    this._params = params;
    this._ima = ima;
    this._data = data;
  }

  tech() {
    return this._tech;
  }

  params() {
    return this._params;
  }

  ima() {
    return this._ima;
  }

  data() {
    return this._data;
  }

  adPlaylistId() {
    return this._adPlaylistId;
  }

  currentAdType() {
    return this._currentAdType;
  }

  adSkipButton() {
    return this._adSkipButton;
  }

  init() {
    if (this.params().prerollTag()) {
      this.setup();
      this.addListenerForCreativeButtonClick()
    }
  }

  addListenerForCreativeButtonClick() {
    window.addEventListener('message', this.onMessage.bind(this))
  }

  removeListenerForCreativeButtonClick() {
    window.removeEventListener('message', this.onMessage.bind(this))
  }
    
  onMessage(message) {
    if(message.data.type !== 'SIMID:Creative:buttonClick') return
    if(message.data.args?.buttonType !== 'AddToMyList') return;
    const listableType = message.data.args?.params?.listableType;
    const listableId = message.data.args?.params?.listableId;
    
    (async () => {
      try {
        const metaCsrf = document.querySelector('meta[name="csrf-token"]')
        const csrfToken = metaCsrf.getAttribute('content')
        
        const baseURL = window.location.origin;
        const URL = `${baseURL}/my-list?listable_id=${listableId}&listable_type=${listableType}`
        let response = await fetch(URL, {
          method: 'POST',
          credentials: 'include',
          headers: {    
              'X-CSRF-Token': csrfToken,
            }
          })
        
        await response.json()
      } catch(e) {
        // do nothing
      }
    })()
  }

  setup() {
    this._currentAdType = "pre";

    if (this.params().adTagIsVmap()) {
      this._adPlaylistId = UUID.v4();
    } else {
      this._adPlaylistId = null;
    }

    this.bindRequestAdsPlay();
    this.setupAdSkipButton();
  }

  setupAdSkipButton() {
    this._adSkipButton = new AdSkipButton({ tech: this.tech(), ima: this.ima(), data: this.data() });
    this.adSkipButton().init();
  }

  bindRequestAdsPlay() {
    try {
      this.setupIma();
    } catch (e) {
      const imaAdContainer = document.querySelector('#ima-ad-container');
      if (imaAdContainer) {
        imaAdContainer.remove();
      }
    }
  }

  setupIma() {
    if (!this.ima().imaAlreadySetup()) {
      this.ima().setup(this.tech().id(), this.params().prerollTag());
    }
  }
}